<template>
  <div class="page-content">
    <!-- <div class="page-content-title">订单审核</div> -->
    <div class="main-content">
      <a-card style="width: 100%" size="small">
        <div class="flex-box">
          <div class="left">
            <a-space size="small">
              {{ orderDetail.studentName }}
              <a-tag color="red">{{ selectDictLabel(gradeList, orderDetail.grade) }}</a-tag>
              <a-tag color="green">{{ selectDictLabel(studentStatusList, orderDetail.studentStatus) }}</a-tag>
            </a-space>
            <div class="address">{{ orderDetail.studentSchoolName }}</div>

          </div>
          <a-button type="link">{{ selectDictLabel(orderStatusList, orderDetail.orderStatus) }}</a-button>
        </div>
      </a-card>

      <a-card style="width: 100%" size="small" title="订单信息" class="mt-10">
        <div style="display: flex;">
          <Cell label="订单类型">
            <a-tag color="green">{{ selectDictLabel(orderTypeList, orderDetail.type) }}</a-tag>
          </Cell>
          <Cell label="经办校区" :value="orderDetail.schoolName" />
        </div>
        <Cell label="附件">
          <a-image-preview-group>
            <a-image :width="50" style="padding-left: 3%;" v-for="annex in orderDetail.annexVoList" :key="annex.uid"
              :src="annex.url" />
          </a-image-preview-group>
        </Cell>
        <Cell label="订单备注" :value="orderDetail.remark" />
        <Cell label="失败原因" :value="orderDetail.failedRemark" v-if="orderDetail.failedRemark" />
      </a-card>

      <a-card style="width: 100%" size="small" title="支付信息" class="mt-10">
        <Cell label="订单原价" :value="'¥' + orderDetail.courseAmount" />
        <div style="display: flex;">
          <Cell label="应收" :value="'¥' + orderDetail.shouldPay" />
          <Cell label="优惠金额" :value="'¥' + orderDetail.preferentialAmount" />
        </div>

        <div style="margin-top: 10px;" v-for="pay in orderDetail.payList" :key="pay.payId">
          <Cell label="支付类型">
            <a-tag color="red">{{ selectDictLabel(payTypeList.value, pay.payType) }}</a-tag>
          </Cell>
          <Cell label="支付金额" :value="pay.payAmount" />
          <Cell label="支付流水号/单号" :value="pay.serialNumber" />
        </div>
      </a-card>
      <a-card style="width: 100%" size="small" title="课程信息" class="mt-10">
        <div v-for="course in orderDetail.studyCourseList" :key="course.orderCourseId">
          <div class="courseTitle">
            <span style="margin-right: 7px;">{{ course.courseName }}</span>
            <a-tag color="red">{{ selectDictLabel(gradeList, course.grade) }}</a-tag>
            <a-tag color="blue">{{ selectDictLabel(subjectList, course.subject) }}</a-tag>
          </div>
          <div style="font-size: 12px">
            <Cell label="课程原价" :value="'￥' + course.coursePay" />
            <div style="padding: 10px 15px;">￥{{ course.totalPrice }}×{{ course.buyClassHourCount }}（
              <span style="color: red;">赠送{{ course.giftClassHourCount }}</span>
              ）
            </div>
            <!-- <Cell label="其它扣减" :value="'￥' + course.reductionAmount" /> -->
            <Cell label="优惠后金额" :value="'￥' + getPayAmount(course)" />
          </div>
        </div>
      </a-card>
    </div>

    <div class="page-content-footer" v-if="orderDetail.orderStatus == 1 || orderDetail.orderStatus == 7">
      <a-button type="primary" style="width: 45%;height: 50px;" danger @click="cancel">不通过</a-button>
      <a-button type="primary" style="width: 45%;height: 50px;margin-left: 3%;" @click="confirm">通过</a-button>
    </div>

    <van-dialog v-model:show="show" title="备注" show-cancel-button @confirm="auditFailed">
      <van-field v-model="auditDetail.remark" placeholder="" label-align="left" rows="2" autosize type="textarea"
        show-word-limit />
    </van-dialog>


  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import Cell from '@/component/cell.vue'
import { getOrderForWx, wxAudit } from '@/api/order'
import { showConfirmDialog } from 'vant';
import { showSuccessToast } from 'vant';
import { ensureWecomLogin } from '@/utils/wecomAuth';
import { useDict, selectDictLabel } from '@/utils/dict'
import { useRoute } from 'vue-router'

const route = useRoute()
const {
  grade_list: gradeList,
  student_status: studentStatusList,
  order_type: orderTypeList,
  order_status: orderStatusList,
  pay_type: payTypeList,
  course_subject: subjectList
} = useDict(
  'grade_list',
  'student_status',
  'order_type',
  'order_status',
  'pay_type',
  'course_subject'
)

const orderDetail = ref({})
const orderId = ref()
const show = ref(false)
const auditDetail = reactive({
  orderId: undefined,
  auditResult: undefined,
  remark: ''
})

onMounted(async () => {
  if (route.query.state) {
    orderId.value = route.query.state
  }
  await ensureWecomLogin(route.query.code)
  initData()
})

function initData() {
  initOrder(orderId.value)
}

function initOrder(targetOrderId) {
  getOrderForWx(targetOrderId).then(response => {
    auditDetail.orderId = response.orderId
    orderDetail.value = response
  })
}


function getPayAmount(course) {
  let payAmount = course.coursePay
  if (orderDetail.value.discountRate && orderDetail.value.discountRate != 0) {
    payAmount = payAmount * (orderDetail.value.discountRate / 10)
  }
  if (course.reductionAmount) {
    payAmount = payAmount - Number(course.reductionAmount)
  }
  return payAmount
}

function auditFailed() {
  auditDetail.auditResult = 0
  wxAudit(auditDetail).then(() => {
    showSuccessToast("操作成功")
    initOrder(auditDetail.orderId)
  });
}

function confirm() {
  showConfirmDialog({
    title: '',
    message: '确认该订单审核通过？',
  }).then(() => {
    auditDetail.remark = ''
    auditDetail.auditResult = 1
    wxAudit(auditDetail).then(() => {
      showSuccessToast("操作成功")
      initOrder(auditDetail.orderId)
    });
  }).catch(() => {
  })
}

function cancel() {
  show.value = true
}
</script>

<style scoped>
.page-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  overflow: auto;
  padding: 10px;
}

.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-box .left {
  flex: 1;
}

.page-content-title {
  text-align: center;
  padding: 10px;
}

.address {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.mt-10 {
  margin-top: 10px;
}

.courseInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-content-footer {
  text-align: center;
  padding: 10px;
}

.courseTitle {
  color: #1890ff;
  display: flex;
  align-items: center;
}

.courseTitle::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 15px;
  background: #1890ff;
  margin-right: 5px;
}
</style>
